import { Record } from "immutable";

import compactDisplays from "../../../../constants/compactDisplay";
import createFromJS from "../../../createFromJS";

export const ItemTypeDisplayValues = Record({
  id: null,
  icon: null,
  color: null,
  label: null,
  pluralLabel: null,
  compactDisplay: compactDisplays.IDENTIFIER
});

createFromJS.registerCallback("ItemTypeDisplayValues", createFromJS.createPrimitiveCallback(ItemTypeDisplayValues));
